import { render, staticRenderFns } from "./NodeChrome.vue?vue&type=template&id=c38f0b9e&"
import script from "./NodeChrome.vue?vue&type=script&lang=ts&"
export * from "./NodeChrome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports